import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import IconButton from '@mui/material/IconButton';
import { useDispatch, useSelector } from 'react-redux';

// LOCAL IMPORTS
import { sideMenuRoutes } from '@/router/config';
import { normalizeRole, ROLES } from '@/router/roles';
import { MenuIcon } from '@/assets/icons/MenuIcon';
import { capitalizeFirstLetter, useKitStates } from '@/utils';
import { getProfileAPIFn } from '@/redux/features/dashboardProfile/dashboardProfileSlice';

export const Header = ({ isSideMenuOpen, setSideMenuOpen }) => {
  const { userId } = useKitStates()
  const [name, setName] = useState('');
  const currentUser = useSelector(state => state?.currentUser?.currentUser);
  const role = normalizeRole(currentUser?.userRole) ?? ROLES.CREATOR;
  const routes = sideMenuRoutes[role] ?? [];

  // GET LOCATION PATH
  const location = useLocation();
  const dispatch = useDispatch();

  // CURRENT MODULE
  const currentModule = routes?.find(route =>
    route?.child?.some(childRoute => location.pathname === childRoute.path)
  );

  const currentRoute = currentModule?.child?.find(
    childRoute => location?.pathname === childRoute?.path
  );

  const getUserDetails = async () => {
    if (role !== ROLES.CREATOR || !userId) return;
    const userDetails = await dispatch(getProfileAPIFn({ userId }));
    setName(userDetails?.payload?.firstName);
  };

  useEffect(() => {
    if (role !== ROLES.CREATOR || currentModule?.text !== 'Profile') return;
    getUserDetails();
  }, [currentRoute, role, currentModule?.text]);



  // STATES
  return (
    <React.Fragment>
      <div
        className={`relative h-20 md:h-[110px] !bg-secondary-gorgias-light flex justify-center md:items-start items-center flex-col ${isSideMenuOpen ? 'px-[1rem]  md:px-[1.5rem]' : 'px-[1rem] md:px-[2rem]'}`}>
        <MenuIcon
          className='absolute self-start cursor-pointer md:hidden'
          onClick={() => setSideMenuOpen(true)}
        />
        <IconButton
          size='small'
          className={`!hidden !absolute -left-[15px] top-1/2 -translate-y-1/2 md:!flex justify-center items-center !transition-transform !duration-300 ${isSideMenuOpen ? '' : '!translate-x-3'}`}
          onClick={() => setSideMenuOpen(!isSideMenuOpen)}
        >
          <KeyboardArrowLeftRoundedIcon
            fontSize='small'
            className={`!bg-secondary-lightMintGreen border border-secondary-darkMintGreen !text-black rounded-full transition-transform duration-300 ${isSideMenuOpen ? 'rotate-0' : 'rotate-180'}`}
          />
        </IconButton>

        {currentModule?.text === 'Profile' ? (
          <p className='text-base font-outfit !text-neutral font-light'>{`${capitalizeFirstLetter(name) || 'User'}'s`} {currentModule?.text}</p>
        ) : (
          <p className='text-base font-outfit !text-neutral font-light'>{currentModule?.text}</p>
        )}
        <p className='mt-0.5 text-xl font-medium md:text-3xl font-notodisplay'>{currentRoute?.text}</p>
      </div>
    </React.Fragment>
  );
};
